<template>
  <div class="page-container">
    <div class="list-container">
      <div class="form-container">
        <h2>Iniciar sesión</h2>
        <p>Ingrese sus credenciales para continuar:</p>
        <!-- Campo de email -->
        <div class="input-group">
          <label for="email">Email</label>
          <InputText v-model="email" id="email" placeholder="Ingrese su email" />
        </div>
        <!-- Campo de contraseña -->
        <div class="input-group">
          <label for="password">Contraseña</label>
          <InputText v-model="password" id="password" type="password" placeholder="Ingrese su contraseña" />
        </div>
        <!-- Botón de Iniciar sesión -->
        <Button @click="handleLogin" label="Iniciar Sesión" class="btn-login" />

        <span v-if="loginErrorMessage" class="error-message">{{ loginErrorMessage }}</span>

        <!-- <div class="links"> -->
          <!-- <RouterLink to="/reset-contraseña">¿No recuerdas tu contraseña? Restáuralo aquí</RouterLink> -->
        <!-- </div> -->
        <div class="links">
          <RouterLink to="/register">¿No tienes cuenta? Regístrate aquí</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { login } from '@/services/firebaseService';
import { useUserStore } from '@/stores/user';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { RouterLink } from 'vue-router';
import { useRouter } from 'vue-router';

export default {
  components: {
    InputText,
    Button,
    RouterLink
  },
  setup() {
    const userStore = useUserStore();
    const email = ref('');
    const password = ref('');
    const loginErrorMessage = ref('');
    const router = useRouter();

    const handleLogin = async () => {
      try {
        const user = await login(email.value, password.value);
        userStore.setUser(user);
        router.push('/');
      } catch (error) {
        console.error("Login failed", error);
        loginErrorMessage.value = error.message;
      }
    };

    return {
      email,
      password,
      handleLogin,
      loginErrorMessage,
    };
  }
};
</script>

<style scoped>
/* Respetamos la estructura de .list-container que mencionaste */
.list-container {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

/* Estilos adicionales */
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 400px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  color: #333;
}

p {
  text-align: center;
  font-size: 14px;
  color: #666;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-group label {
  font-size: 14px;
  color: #333;
}

.input-group .p-inputtext {
  padding: 0.75rem;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.input-group .p-inputtext:focus {
  border-color: #007bff;
  outline: none;
}

/* Estilo del botón (morado) */
.btn-login {
  background-color: #6a0dad; /* Morado */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-login:hover {
  background-color: #8a2be2; /* Morado más claro */
}

/* Estilo de los enlaces */
.links {
  text-align: center;
  margin-top: 15px;
}

.links .p-link {
  color: #6a0dad; /* Morado */
  font-size: 14px;
}

.links .p-link:hover {
  text-decoration: underline;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 10px;
}
</style>
